export interface INotesArrowData {
  offset: { top: number; left: number };
  text: string;
  tipDirection: 'top' | 'right' | 'bottom' | 'left';
  arrowAlign?: 'center' | 'right' | 'left';
  textAlign?: string;
  scale?: number;
  /**
   * Which edge of the anchor's bounding rect drives the tooltip's Y
   * origin. Default `'top'` (legacy: tooltip sits relative to anchor's
   * top edge). `'bottom'` is useful when you want the tooltip to dock
   * under a container regardless of where the highlighted child sits
   * inside it — e.g. the empty-knowledge-base note that should always
   * hang under the menu card, not float at the link's mid-height.
   */
  anchorEdge?: 'top' | 'bottom';
  /**
   * When true, the tooltip is horizontally centred on the anchor's
   * midpoint (`translateX(-50%)` on the host, X reference = anchor.left
   * + anchor.width / 2). Use together with a tight anchor — e.g. an
   * `nb-menu-item .menu-title` span — and the default `arrowAlign:
   * 'center'` so the arrow tip lands exactly on the highlighted word
   * regardless of the translated string's length.
   */
  centerOnAnchor?: boolean;
}

export const notesData: Record<string, INotesArrowData> = {
  addAssistentButton: {
    offset: { top: 50, left: -90 },
    text: 'notes.addAssistentButton.text',
    tipDirection: 'top',
  },
  addKnowledgeBaseButton: {
    offset: { top: 50, left: -225 },
    text: 'notes.addKnowledgeBaseButton.text',
    tipDirection: 'top',
    arrowAlign: 'right',
  },
  addChatStyleButton: {
    offset: { top: 50, left: -225 },
    text: 'notes.addChatStyleButton.text',
    tipDirection: 'top',
    arrowAlign: 'right',
  },
  knowledgeBaseEmtpy: {
    // Anchored to the `.menu-title` span of the Wissensbasis link so
    // `getBoundingClientRect()` returns the exact box of the word
    // (i18n-agnostic — DE "Wissensbasis", EN "Knowledge base", whatever
    // the translation). centerOnAnchor centres the tooltip horizontally
    // on the word's midpoint; arrowAlign defaults to 'center' so the
    // tip lands directly on the word. anchorEdge 'bottom' + offset.top
    // hangs the body a fixed distance below the word's lower edge so
    // the menu link itself stays uncovered and the bounce animation
    // has clean space to play in.
    offset: { top: 20, left: 0 },
    text: 'notes.knowledgeBaseEmtpy.text',
    tipDirection: 'top',
    centerOnAnchor: true,
    anchorEdge: 'bottom',
  },
};
